/**
 * `useAnalytics` is a custom hook that returns a function that can be used to
 * send analytics events to Google Tag Manager.
 * In order to send an event to Google Analytics through Google Tag Manager, you must make sure the
 * event is configured in the GTM property.
 * https://tagmanager.google.com/#/container/accounts/6001303783/containers/90701554/
 */
export const useAnalytics = () => {
  const sendEvent = (event: string, data: Record<string, string>) => {
    if (typeof window === "undefined") {
      return;
    }
    var dataLayer = (window as any).dataLayer;
    if (dataLayer) {
      dataLayer.push({
        event,
        ...data,
      });
    }
  };

  return { sendEvent };
};
